module.exports = __webpack_public_path__ + "img/banner-12-2@2x.f6fa6fcf.jpg";